module.exports = __webpack_public_path__ + "static/media/banner3.935f02fa.png";